import React from 'react';
import Field from '../Field';
import { FREQUENCIES, FREQUENCY_UNITS } from '../../domain/recurrence';
import { recurrenceChoices } from '../../domain/expenseForms';
import s from './EntryForm.module.css';
import { DateInput } from '../RegionInputs';

const title = (str) => str.charAt(0).toUpperCase() + str.slice(1);

// One-time or repeating, and if repeating, how often. A control: it holds no
// state and every change goes straight back out through onChange.
export default function RecurrenceFields({ form, onChange, type, error }) {
  const recurring = form.recurrence === 'recurring';

  return (
    <div className={s.divider}>
      <div className={s.sectionTitle}>Recurrence</div>

      {recurrenceChoices(type).map(({ id: value, label }) => (
        <label key={value} className={s.checkRow}>
          <input
            type="radio"
            name="recurrence"
            checked={form.recurrence === value}
            onChange={() => onChange({ recurrence: value })}
          />
          <span>{label}</span>
        </label>
      ))}

      {recurring ? (
        <div className={s.section}>
          <div className={s.pair}>
            <Field label="Frequency">
              <select
                className={s.input}
                value={form.frequency}
                onChange={(e) => onChange({ frequency: e.target.value })}
              >
                {FREQUENCIES.map((f) => <option key={f} value={f}>{title(f)}</option>)}
              </select>
            </Field>
            {/* The pair by hand — the control is inside a wrapper, which
                `Field` will not label for us (#383). */}
            <Field label="Repeats Every" htmlFor="expense-repeat-interval">
              {/* The unit follows the frequency — see the note on the calendar
                  drawer's copy of this control. */}
              <span className={s.suffixed}>
                <input
                  id="expense-repeat-interval"
                  className={s.input}
                  type="number"
                  min="1"
                  value={form.interval}
                  onChange={(e) => onChange({ interval: e.target.value })}
                />
                <span className={s.suffix}>{FREQUENCY_UNITS[form.frequency] || ''}</span>
              </span>
            </Field>
          </div>

          <label className={s.checkRow}>
            <input
              type="checkbox"
              checked={form.repeatIndefinitely}
              onChange={(e) => onChange({ repeatIndefinitely: e.target.checked })}
            />
            <span>Repeat indefinitely</span>
          </label>

          {/* When it stops, not how many times it runs — the same question MMS
              asks, and the same one a studio can answer about a lease. `min`
              is the entry's own date: a rule ending before it starts contains
              nothing. */}
          {!form.repeatIndefinitely ? (
            <div className={s.narrow}>
              {/* The refusal is inline and arrives on submit, like every other
                  one on this form (#116). */}
              <Field label="Repeat Until" error={error}>
                <DateInput
                  className={s.input}
                  min={form.occurredOn}
                  value={form.endDate}
                  data-error={error ? 'true' : undefined}
                  onChange={(e) => onChange({ endDate: e.target.value })}
                />
              </Field>
            </div>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
